// src\app\tos-modal\tos-modal.component.ts
import { Component, ChangeDetectionStrategy } from '@angular/core';
import { AcceptTosInterface, UserService } from "../../services/user/user.service";
import { User } from "../../model/User";
import { Router } from '@angular/router';

/**
 * TosPageComponent represents the page that displays terms of service to the user. It is a special
 * page and breaks the traditional flow of routes in the application.
 */
@Component({
    selector: 'app-tos-page',
    templateUrl: './tos-page.component.html',
    styleUrls: ['./tos-page.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TosPageComponent {
  /** Loading flag */
  public isLoading: boolean = true;

  /** Checkbox agreement status */
  public isCheckboxChecked: boolean = false;

  /** Status on user acceptance of TOS */
  public isTosAccepted: boolean = false;

  /** User's role */
  public userRole: "SUPPLIER" | "BORROWER" | null = null;

  /** Any error associated with accepting TOS process */
  public error: string = "";

  /**
   * Constructor to initialize services
   * 
   * @param _userService - UserService instance to manage user data and state
   * @param _router - Router instance to navigate between routes
   */
  constructor(
    private _userService: UserService,
    private _router: Router,
  ) { 
    // Subscribe to user service to get user data and keep user's role updated
    this._userService.user$.subscribe(
      (user: User | null) => {
        // If user isn't defined return
        if (user == undefined) {
          console.error("[ERR]: user is null or undefined in tos page");
          return;
        }
        this.isLoading = false;

        // If user is defined, set the user role based on the company type
        this.userRole = user.companies[0].companyType;
        this.isTosAccepted = this._userService.tosAccepted;
      }
    );
  }

  /**
   * Perform an action when the user clicks accept
   */
  onAccept(): void {
    const self = this;

    // Use the user service to accept the TOS and get the response
    this._userService.acceptTOS(this._userService.user!).subscribe({
      next: (accepted: boolean) => {
        if (accepted) {
          // On successful response, navigate back to default home path
          console.log("[INFO]: TOS accepted successfully");
          self._router.navigate([self._userService.defaultNavPath]);
        } else {
          // On fail, set the error message
          console.log("[INFO]: TOS endpoint returned bad");
          this.error = 'Failed to accept TOS. Please contact an administrator.';
        }
      },
    });
  }
}
